const items = [
  "100% Virgin Spec Base Oils",
  "API & ACEA Standards",
  "Meets or Exceeds OEM Approvals",
  "Bulk Supply — 210L Drums",
  "SA's Fastest Growing Locally Blended Oil Brand",
  "When Performance Matters, We Deliver!",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-gold/15 bg-coal/60 py-7 overflow-hidden select-none"
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((t, i) => (
              <span
                key={`${half}-${i}`}
                className={`mx-6 font-heading font-extrabold uppercase tracking-[0.15em] text-2xl sm:text-3xl ${
                  i % 2 ? "text-outline-gold" : "text-gold/90"
                }`}
              >
                {t} <span className="text-gold/40 mx-4">•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
